document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('[atlas-cart-form]');

    if (!form) return;

    function updateFormAction() {
        let action = form.getAttribute('action') || '';

        if (action.includes('&locale=en-CA')) {
            action = action.replace('&locale=en-CA', '&locale=en-AU');
            form.setAttribute('action', action);
        } else if (!action.includes('locale=')) {
            if (action.includes('?')) {
                action += '&locale=en-AU';
            } else {
                action += '?locale=en-AU';
            }
            form.setAttribute('action', action);
        }

        console.log(`cart action = `, action);
    }

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'action') {
                updateFormAction();
            }
        }
    });

    observer.observe(form, { attributes: true });

    updateFormAction();
});
